<template>
  <div class="">
    <public-title>
      企业详情
    </public-title>
    <!--企业信息-->
    <div class="storeDetail">
      <!--基本信息-->
      <div class="storeDetail-left">
        <enterpriseinfo :storeInfo="storeInfo" :bankcard_arr="bankcard_arr" :type="type"></enterpriseinfo>
        <!--企业相册-->
        <corporate-album :storeInfo="storeInfo" :store_id="store_id" v-if="type==3"></corporate-album>
        <!--用户活跃-->
        <user-activity :storeInfo="storeInfo" :order_arr="order_arr" :type="type"></user-activity>
      </div>
      <!--认证信息-->
      <div class="storeDetail-right">
        <auth-info :storeInfo="storeInfo" :type="type" ></auth-info>  
        <!--重新认证信息-->
        <auth-info :storeInfo="edit_verify" :type="type" class="mt-3" :edit_verify="true" v-if="edit_verify.title"></auth-info>
      </div>
    </div>
      <!--操作说明-->
    <div class="review-info" v-if="storeInfo.verify==2||edit_verify.title">
        <div class="title">
            审核操作
        </div>
        <div class="bottom">
            <el-button type="success" @click="passStore" class="mr-2">通过审核</el-button>
            <el-button type="danger"  @click="refuseVerify = true;">审核拒绝</el-button>
        </div>
    </div>
    <!--审核拒绝弹窗-->
    <el-dialog title="选择拒绝原因" :visible.sync="refuseVerify" center width="700px" top="17%">
        <el-radio-group  v-model="formData.action_remark">
            <el-radio :label="item"  v-for="(item,index) in refuseArr" :key="index" class="mb-2 ml-0 mr-4">{{item}}</el-radio>
            <p class="d-center-start" v-if="formData.action_remark==='其他'">其他：
                <el-input v-model="verifyRemark" class="w-100 mt-2"  placeholder="请输入拒绝原因"/>
            </p>
        </el-radio-group>
        <div slot="footer">
            <el-button @click="refuseVerify = false">取 消</el-button>
            <el-button type="primary" @click="verifyControl(2)">确 定</el-button>
        </div>
    </el-dialog>
    <!--通过认证门店弹窗-->
    <el-dialog title="请设置门店对接人" :visible.sync="passVerify" center width="700px" top="17%">
      <el-select  v-model="formData.person_liable_id" class="w-100" placeholder="请设置门店对接人" v-if="passVerify">
        <el-option v-for="item in staffListArr"
                   :key="item.id"
                   :label="item.truename"
                   :value="item.id" />
      </el-select>
      <div slot="footer">
        <el-button @click="passVerify = false">取 消</el-button>
        <el-button type="primary" @click="passStore(1)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions,mapState} from 'vuex'
import { debounce } from "lodash";
import Enterpriseinfo from './Components/Enterpriseinfo.vue';
import CorporateAlbum from './Components/CorporateAlbum.vue';
import UserActivity from './Components/UserActivity.vue';
import AuthInfo from './Components/AuthInfo.vue';
export default {
  name:  'StoreDetail',
  components: {
    Enterpriseinfo,
    CorporateAlbum,
    UserActivity,
    AuthInfo
  },
  props: {},
  data() {
    return {
      storeInfo:{                    //基本信息
        pic:[],
        pic_lobby:[],
        pic_interior:[],
        room_arr:[],
        meeting_arr:[],
      },                  
      bankcard_arr:[],                //银行卡列表
      order_arr:{},                   //活跃信息
      edit_verify:{                   //重新认证信息
        title:'',
      },                
      refuseVerify:false,            //审核拒绝弹窗
      refuseArr: [
          '单位名称有误',
          '外观图不正确',
        
          '房型信息填写有误',
          '会议室信息填写有误',
                    '单位地址有误',
                      '内景图不正确',
          '营业执照信息不正确',
          '其他'
      ], 
      verifyRemark:'',                  //拒绝原因
      //倒计时
      countDownNum: 5,
      //不可操作
      isDisabled:true,
      passVerify:false,            //通过认证门店弹窗
      formData:{                   //提交信息
        person_liable_id:0,
        action_remark:'',
      }
    };
  },
  computed: {
    ...mapState(['staffLists']),
    //业务负责人备选项
    staffListArr() {
      let arr = $.extend(true, [], this.staffLists.lists);
      arr = arr.filter(item => !item.truename.includes('测试管理员'))
      arr.unshift({
        id:0,
        truename:'无'
      })
      return arr;
    },
    type(){return Number(this.$route.query.type)},
    store_id(){return Number(this.$route.query.id);},
  },
  watch: {},
  created() {},
  mounted() {
    this.getStoreData();
  },
  methods: {
    ...mapActions(['POST_Admin_GetStoreInfo','getUserStaffLists','verifyStore']),
      //获取门店详情
      getStoreData() {
        this.POST_Admin_GetStoreInfo({
          data:{
            store_id:this.store_id
          },
          type:this.type*1,
          successFun:(res)=>{
            if(this.type==3){
                res.info.pic=res.info.pic.split(',')||[];
                res.info.pic_lobby=res.info.pic_lobby.split(',')||[];
            }
            this.storeInfo=res.info;
            this.bankcard_arr=res.bankcard_arr||[];
            this.order_arr=res.order_arr||{};
            if(res.edit_verify){
              this.edit_verify=res.edit_verify||{};
            }
          }
        })
      },
      //通过认证门店
      passStore() {
        if(!this.passVerify){
          this.passVerify = true;
          if(this.staffLists.total==0){
            this.getUserStaffLists({num:100});
          }
        }else{
          this.reviewBankcard(1)
        }
      },
      //拒绝通过
      verifyControl(){
          if (!this.formData.action_remark) {
              this._alert('请选择拒绝理由',null,'error');
              return;
          }
          if (this.formData.action_remark === '其他'&& !this.verifyRemark) {
              this._alert('请填写其他理由',null,'error');
              return;
          }
          this.formData.action_remark =  this.verifyRemark || this.formData.action_remark;
          this.reviewBankcard(2)
      },
      /*审核认证门店*/
      reviewBankcard: debounce(function(flag)  {
        this.passVerify = false;
        this.verifyStore({
          data:{
            ...this.formData,
            store_id:this.store_id,
            action_flag:flag,
          },
          review:{
            type:this.type,
            confirm:this.edit_verify.title?1:0,
          },
          successFun:() => {
            this.$message({message: '操作成功',type: 'success'});
            this.goBack();        //返回上一页
          }
        });
      }, 300),
      //返回上一页如果来源是当前域名，否则跳转首页路由
      goBack() {
        const currentOrigin = location.origin
        const ref = document.referrer

        // 有来源链接
        if (ref) {
          try {
            const refObj = new URL(ref)
            // 判断来源域名 和 当前域名一致
            if (refObj.origin === currentOrigin) {
              this.$router.back()
              return
            }
          } catch (err) {}
        }
        // 来源为空 / 不是当前域名 → 跳首页
        this.$router.push({name:'CenterIndex'})
      }
  }
};
</script>

<style lang="scss" scoped>
  .storeDetail{
    display: flex;
    justify-content:space-between;
    min-width: 1200px;
  }
  .storeDetail-left{
    width: 60%;
  }
  .storeDetail-right{
    width: 38%;
  }
  .review-info{
    margin-top: 20px;
    background-color: #fff;
    border-radius: 5px;
    text-align: left;
    width: 100%;
    overflow: hidden;
    box-shadow: 0px 0px 7px #eee;
    .title{
        background-color: #f5f7fc;
        padding: 18px;
        border-radius: 5px;
        font-size: 16px;
        font-weight: bold;
        width: 100%;
        color: #19324e;
        display: flex;
        align-items: center;
        i{
            color: var(--smtc-color-primary);
            margin-right: 10px;
            font-weight: normal;
        }
    }
  }
  .bottom{
    display: flex;
    justify-content: center;
    margin:20px 0;
  }
</style>

